import {compose} from 'recompose'
import withSelectFetch from '../../elements/Select/withSelectFetch'
import withSpinning from '../../elements/HOC/withSpinning'
import withSort from '../../elements/HOC/withSort'
import CustomSelect from '../../elements/Select/CustomSelect'

const StateSelect = compose(
  withSelectFetch({dropdown: 'general', name: 'state', forceFetch: true}),
  withSpinning,
  withSort,
)(CustomSelect)
export default StateSelect
